import { BrowserConsoleAppender, Level, PatternLayout, getRootLogger } from 'log4javascript';

export function initialize(_application: unknown): void {
  const appender = new BrowserConsoleAppender();
  appender.setLayout(new PatternLayout('%d %p %c - %m%n'));
  appender.setThreshold(Level.ALL);
  getRootLogger().addAppender(appender);
  // The default treshold if we don't overrule it on a specific logger
  getRootLogger().setLevel(Level.INFO);
}

export default {
  initialize,
};
